import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import { usePageLocale } from '../../components/i18n/usePageLocale'
import back from "../../assets/images/elements/aboutHeader.jpg";
import article_img from "../../assets/images/articles/8_full.jpeg"
import articlePdf from "../../resources/8-i-have-a-dream-king.pdf";
import ArticleLike from '../../components/ArticleLike'

export const Article8IHaveADream = () => {
    const ready = usePageLocale('article8');
    if (!ready) return <div style={{ padding: '60px', textAlign: 'center', color: '#999' }}>•••</div>;
    return (

        <section className='text_container_light'>
            <div className='container_100'>
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle8Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle8Title")}</h2>

                            <p>{t("resourceArticle8Author")}</p>
                            <div style={{ marginTop: '10px' }}>
                                <a
                                    href={articlePdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-download-link"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: '#b22222',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>📄</span>
                                    {t("resourceArticleDownloadOriginal")}
                                </a>
                            </div>

                            <p style={{ fontSize: '13px', color: '#777', fontStyle: 'italic' }}>
                                {t("resourceArticle8ConferenceNote")}
                            </p>

                            <hr />
                            <br/>

                            <img
                                src={article_img}
                                alt={t("resourceArticle8Title")}
                                className="article-img"
                            />

                            <br />
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P6") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P8") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P9") }} /></p>

                        </div>

                        {/* ПРАВА КОЛОНКА */}
                        <div>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P10") }} /></p>
                            <br/>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P11") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P12") }} /></p>

                            <h3 className='menuColor'>{t("resourceArticle8Sec1")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P13") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P14") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P15") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P16") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P17") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P18") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P19") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P20") }} /></p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle8Sec2")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P21") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P22") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P23") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle8P24") }} /></p>
                            <br/>

                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle8Copyright")}
                            </p>
                            <br/>

                        </div>
                    </div>
                    <ArticleLike articleId='8-mlk-i-have-a-dream' />
                </div>
                <br />
            </div>
        </section>
    )
}
